import React from 'react'
import './index.css'

function Index() {
  return (
    <div className='AppFooter'>.....</div>
  )
}

export default Index